module.exports = __webpack_public_path__ + "img/face-frown.fa3ac7a3.svg";